import styled from 'styled-components';

import { Button } from '@/shared/components/ui/button/button';
import { SelectButton } from '@/shared/components/ui/button/select-button/select-button';

export const ThemeSwitcherMenuItem = styled(SelectButton)`
  && {
    ${({ theme }) => theme.typography.p8};
    color: ${({ theme }) => theme.palette.text.primary};

    & > div:first-of-type {
      svg {
        width: 1.25rem;
        height: 1.25rem;
      }
    }
  }
`;

export const ThemeSwitcherSelect = styled(Button)`
  && {
    height: 3.25rem;
    padding: 0.75rem;

    svg:first-of-type {
      width: 1.75rem !important;
      height: 1.75rem !important;
    }
  }
`;
